import React, { useEffect, useState } from "react"
import "./DeletedComments.scss"
import DeletedApi from "Api/DeletedApi"
import {
  Col,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  Card,
  CardBody,
} from "reactstrap"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import DataTableLoader from "SkeletonLoader/DataTableLoader"
import { useNavigate } from "react-router-dom"
import { StandardPagination, ActionIcon } from "components/Common"
const DeletedComments = () => {
  document.title = "Deleted Comments"

  const accessToken = localStorage.getItem("accessToken")
  const [deletedComments, setDeletedComments] = useState([])
  const [page, setPage] = useState(1)
  const [totalRecords, setTotalRecords] = useState(0)
  const [limit, setLimit] = useState(10)
  const [loading, setLoading] = useState(true)
  const [selectedComment, setSelectedComment] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false)

  const navigate = useNavigate()
  const breadcrumbItems = [
    { label: "Pixwik", link: "/" },
    { label: "Deleted", link: "/deleted-comments" },
    { label: "Deleted Comments" },
  ]
  const handleBreadcrumbClick = link => {
    if (link !== "#") {
      navigate(link)
    }
  }

  const getAllDeletedComments = () => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      params: {
        limit: limit,
        page: page,
      },
    }

    DeletedApi.getAllDeletedComment(config)
      .then(response => {
        setLoading(false)
        setDeletedComments(response.data.data || [])
        setTotalRecords(response.data.totalDeletedComment || 0)
      })
      .catch(error => {
        setLoading(false)
      })
  }

  useEffect(() => {
    getAllDeletedComments()
  }, [accessToken, page, limit])

  const totalPages = Math.ceil(totalRecords / limit)

  const formatDate = dateString => {
    return new Date(dateString).toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    })
  }
  const handleViewComment = comment => {
    setSelectedComment(comment)
    setIsModalOpen(true)
  }

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen)
    if (!isModalOpen) setSelectedComment(null)
  }

  return (
    <div className="deleted-comments-container">
      <Row>
        <Col xs="12">
          <div className="deleted-comments-header d-flex align-items-center justify-content-between">
            <CustomBreadCrumb
              data={breadcrumbItems}
              pageTitle="Deleted Comments"
              handleClick={handleBreadcrumbClick}
            />
          </div>
          <div className="data-table-container">
            <div className="table-responsive">
            {loading ? (
              <DataTableLoader cols={6} />
            ) : (
              <Table className="table mb-0">
                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>GabId</th>
                    <th>Comment</th>
                    <th>Commented By</th>
                    <th>Commented On</th>
                    <th>Deleted Reason</th>
                    <th>Deleted By</th>
                    <th>View</th>
                  </tr>
                </thead>
                <tbody>
                  {deletedComments &&
                    deletedComments.map((item, index) => (
                      <tr key={item._id} className="deleted-comments-table-row">
                        <th scope="row">{(page - 1) * limit + index + 1}</th>
                        <td>{item.gabId}</td>
                        <td>{item.comment[0].comment}</td>
                        <td className="text-capitalize">
                          {item.comment[0].commentedBy || "-"}
                        </td>
                        <td>{formatDate(item.comment[0].commentedOn)}</td>
                        <td>{item.deletedReason}</td>
                        <td>{item.deletedBy?.userName || "-"}</td>
                        <td>
                          <ActionIcon
                            type="view"
                            onClick={() => handleViewComment(item)}
                            tooltip="View Comment"
                          />
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            )}
            </div>
          </div>
          <StandardPagination
            currentPage={page}
            totalPages={totalPages}
            onPageChange={setPage}
          />
        </Col>
      </Row>
      <Modal isOpen={isModalOpen} toggle={toggleModal} size="xl">
        <ModalHeader toggle={toggleModal}>Deleted Comment Details</ModalHeader>
        <ModalBody style={{ maxHeight: '80vh', overflowY: 'auto', padding: '20px' }}>
          {selectedComment && (
            <Card>
              <CardBody>
                <div className="comment-details">
                  <h5 className="mb-4">Comment Information</h5>
                  <Row className="mb-3">
                    <Col md={6}>
                      <p>
                        <strong>Comment ID:</strong> {selectedComment._id}
                      </p>
                      <p>
                        <strong>Gab ID:</strong> {selectedComment.gabId}
                      </p>
                    </Col>
                  </Row>

                  <h5 className="mb-4">Comment Information</h5>
                  <Row className="mb-3">
                    <Col md={12}>
                      <p>
                        <strong>Comment:</strong>{" "}
                        {selectedComment.comment[0].comment}
                      </p>
                      <p>
                        <strong>Commented By:</strong>{" "}
                        {selectedComment.comment[0].commentedBy}
                      </p>
                      <p>
                        <strong>User Type:</strong>{" "}
                        {selectedComment.comment[0].userType}
                      </p>
                      <p>
                        <strong>Commented On:</strong>{" "}
                        {formatDate(selectedComment.comment[0].commentedOn)}
                      </p>
                      <p>
                        <strong>Last Updated:</strong>{" "}
                        {selectedComment.comment[0].updatedOn
                          ? formatDate(selectedComment.comment[0].updatedOn)
                          : "Not updated"}
                      </p>
                    </Col>
                  </Row>

                  <h5 className="mb-4">Interaction Details</h5>
                  <Row className="mb-3">
                    <Col md={6}>
                      <p>
                        <strong>Number of Replies:</strong>{" "}
                        {selectedComment.comment[0].replies.length}
                      </p>
                      <p>
                        <strong>Number of Likes:</strong>{" "}
                        {selectedComment.comment[0].likes.length}
                      </p>
                    </Col>
                  </Row>

                  <h5 className="mb-4">Deletion Information</h5>
                  <Row>
                    <Col md={12}>
                      <p>
                        <strong>Deleted By:</strong>{" "}
                        {selectedComment.deletedBy.userName}
                      </p>
                      <p>
                        <strong>Deleted On:</strong>{" "}
                        {formatDate(selectedComment.deletedOn)}
                      </p>
                      <p>
                        <strong>Deletion Reason:</strong>{" "}
                        {selectedComment.deletedReason}
                      </p>
                    </Col>
                  </Row>
                </div>
              </CardBody>
            </Card>
          )}
        </ModalBody>
      </Modal>
    </div>
  )
}

export default DeletedComments
